<input type="checkbox" [disabled]="isCheckboxDisabled" [checked]="accessToSettings" class="svg-20" (change)="onChange($event)">
